/* 1DL type styles */
/** ******************* */
const EGDSDisplayStyleMap = [['Display Medium', 'display-medium'], ['Display Small', 'display-small']];
new Map(EGDSDisplayStyleMap);
const EGDSHeadlineStyleMap = [['Headline Extra Large', 'headline-extra-large'], ['Headline Large', 'headline-large'], ['Headline Medium', 'headline-medium'], ['Headline Small', 'headline-small'], ['Headline Overline', 'headline-overline']];
new Map(EGDSHeadlineStyleMap);
const EGDSTextStyleMap = [['Text Large', 'text-large'], ['Text Medium', 'text-medium'], ['Text Small', 'text-small']];
new Map(EGDSTextStyleMap);
const EGDSParagraphStyleMap = [['Paragraph Large', 'paragraph-large'], ['Paragraph Medium', 'paragraph-medium'], ['Paragraph Small', 'paragraph-small']];
new Map(EGDSParagraphStyleMap);
/* Type size */
/** ******************* */
const EGDSTypeSizeMap = [[100, 'uitk-type-100'], [200, 'uitk-type-200'], [300, 'uitk-type-300'], [400, 'uitk-type-400'], [500, 'uitk-type-500'], [600, 'uitk-type-600'], [700, 'uitk-type-700'], [800, 'uitk-type-800'], [900, 'uitk-type-900']];
const EGDSTypeSizes = new Map(EGDSTypeSizeMap);
/* Type weight */
/** ******************* */
const EGDSTypeWeightMap = [['regular', 'uitk-type-regular'], ['medium', 'uitk-type-medium'], ['bold', 'uitk-type-bold']];
const EGDSTypeWeights = new Map(EGDSTypeWeightMap);
/* Type alignment */
/** ******************* */
const EGDSTypeAlignmentMap = [['left', 'uitk-type-start'], ['right', 'uitk-type-end'], ['center', 'uitk-type-center']];
const EGDSTypeAlignments = new Map(EGDSTypeAlignmentMap);
/* Type overflow */
/** ******************* */
const EGDSTypeOverflowMap = [['wrap', 'overflow-wrap'], ['truncate', 'truncate'], ['truncate-2-lines', 'truncate-lines-2'], ['truncate-3-lines', 'truncate-lines-3'], ['truncate-4-lines', 'truncate-lines-4']];
const EGDSTypeOverflows = new Map(EGDSTypeOverflowMap);
/* Type hyphens */
/** ******************* */
const EGDSTypeHyphensMap = [['none', 'hyphens-none'], ['manual', 'hyphens-manual'], ['auto', 'hyphens-auto']];
const EGDSTypeHyphens = new Map(EGDSTypeHyphensMap);
/* Heading size */
/** ******************* */
const EGDSHeadingSizeMap = [[1, 'uitk-heading-1'], [2, 'uitk-heading-2'], [3, 'uitk-heading-3'], [4, 'uitk-heading-4'], [5, 'uitk-heading-5'], [6, 'uitk-heading-6'], [7, 'uitk-heading-7'], [8, 'uitk-heading-8']];
const EGDSHeadingSizes = new Map(EGDSHeadingSizeMap);
/* Paragraph size */
/** ******************* */
const EGDSParagraphSizeMap = [[1, 'uitk-paragraph-1'], [2, 'uitk-paragraph-2'], [3, 'uitk-paragraph-3']];
const EGDSParagraphSizes = new Map(EGDSParagraphSizeMap);
/* Type margin */
/** ******************* */
const EGDSTypeMarginMap = [['half', 'uitk-text-spacing-half'], ['one', 'uitk-text-spacing-one'], ['two', 'uitk-text-spacing-two'], ['three', 'uitk-text-spacing-three'], ['four', 'uitk-text-spacing-four'], ['six', 'uitk-text-spacing-six']];
const EGDSTypeMargins = new Map(EGDSTypeMarginMap);
/* Heading tag */
/** ******************* */
const EGDSHeadingTagMap = [['h1', 'h1'], ['h2', 'h2'], ['h3', 'h3'], ['h4', 'h4'], ['h5', 'h5'], ['h6', 'h6']];
const EGDSHeadingTags = new Map(EGDSHeadingTagMap);
const EGDSSubHeadingTagMap = [...EGDSHeadingTagMap, ['p', 'p']];
const EGDSSubHeadingTags = new Map(EGDSSubHeadingTagMap);
/* Type theme */
/** ******************* */
const EGDSTextThemeMap = [['positive', 'uitk-text-positive-theme'], ['negative', 'uitk-text-negative-theme'], ['emphasis', 'uitk-text-emphasis-theme'], ['default', 'uitk-text-default-theme'], ['loyalty', 'uitk-text-loyalty-theme'], ['global-loyalty', 'uitk-text-global-loyalty-theme'], ['inverse', 'uitk-text-inverse-theme'], ['light', 'uitk-text-light-theme'], ['standard', 'uitk-text-standard-theme'], ['secondary', 'uitk-text-secondary-theme']];
const EGDSTextThemes = new Map(EGDSTextThemeMap);
/* Type white space */
/** ******************* */
const EGDSTypeWhiteSpaceMap = [['normal', 'uitk-text-white-space-normal'], ['nowrap', 'uitk-text-white-space-nowrap'], ['pre', 'uitk-text-white-space-pre'], ['pre-wrap', 'uitk-text-white-space-pre-wrap'], ['pre-line', 'uitk-text-white-space-pre-line'], ['break-spaces', 'uitk-text-white-space-break-spaces']];
const EGDSTypeWhiteSpaces = new Map(EGDSTypeWhiteSpaceMap);
/* Text inline (phrase) tags */
/** ******************* */
const EGDSTextInlineTagsMap = [['b', 'b'], ['em', 'em'], ['s', 's'], ['small', 'small'], ['i', 'i'], ['mark', 'mark'], ['strong', 'strong'], ['q', 'q'], ['sub', 'sub'], ['sup', 'sup']];
const EGDSTextInlineTags = new Map(EGDSTextInlineTagsMap);
export { EGDSHeadingSizes, EGDSHeadingTags, EGDSParagraphSizes, EGDSSubHeadingTags, EGDSTextInlineTags, EGDSTextThemes, EGDSTypeAlignments, EGDSTypeHyphens, EGDSTypeMargins, EGDSTypeOverflows, EGDSTypeSizes, EGDSTypeWeights, EGDSTypeWhiteSpaces };